module.exports = __webpack_public_path__ + "static/media/ic_arrow_back_white_24px.eca3d785.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/misc/svg/ic_arrow_back_white_24px.svg
// module id = 352
// module chunks = 0